function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7799 2.58583C13.7123 2.54006 13.6344 2.51157 13.5532 2.50285C13.4719 2.49414 13.3898 2.50546 13.3139 2.53584L8.39996 4.49982H4.49999C3.83695 4.49982 3.20107 4.76321 2.73223 5.23205C2.26339 5.70089 2 6.33677 2 6.99981C2 7.66285 2.26339 8.29873 2.73223 8.76757C3.20107 9.23641 3.83695 9.4998 4.49999 9.4998H8.39996L13.3099 11.4638C13.386 11.495 13.4686 11.507 13.5504 11.4987C13.6322 11.4904 13.7107 11.4621 13.7789 11.4162C13.8472 11.3703 13.9031 11.3083 13.9416 11.2357C13.9801 11.163 14.0002 11.082 13.9999 10.9998V2.99983C13.9999 2.9181 13.9798 2.83762 13.9415 2.76545C13.9031 2.69328 13.8476 2.6316 13.7799 2.58583V2.58583Z",
  fill: "#FDFEFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.11475 10.5H4.88477L6.10676 13.557C6.25448 13.9264 6.54292 14.2221 6.90861 14.3788C7.27431 14.5356 7.6873 14.5407 8.05675 14.393C8.42619 14.2453 8.72182 13.9568 8.8786 13.5911C9.03538 13.2254 9.04047 12.8124 8.89274 12.443L8.11475 10.5Z",
  fill: "#FDFEFF"
});

function SvgAnnouncement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/Announcement.5e8775a0.svg";
export { ForwardRef as ReactComponent };